import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './routes/Home';
import Food from "./routes/Food";
import Spinner from "./routes/Spinner";
import NotFound from "./routes/NotFound";
import './App.scss';

function App() {
  return (
      <Router>
        <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/food' exact component={Food} />
            <Route path='/spinner' exact component={Spinner} />
            <Route component={NotFound} />
        </Switch>
      </Router>
  );
}

export default App;
